module.exports = __webpack_public_path__ + "static/js/dataWorker.f102aef2.chunk.worker.js"